<!-- Calling this orders because we might have an ACTUAL transactions log -->
<template>
  <div class="min-h-full">
    <div
      class="mb-4 flex flex-col items-center justify-between gap-8 py-2 md:flex-row-reverse"
    >
      <div
        class="flex flex-col items-center justify-between gap-2 md:flex-row"
      >
        <ReportCashierFilter v-model="filters.cashierId" />
        <ReportDeviceFilter v-model="filters.deviceId" />
        <DateFilter v-model="dateFilter" />
      </div>

      <SearchInput v-model="searchRaw" />
    </div>

    <div>
      <div class="flex w-full justify-center"> </div>
      <template v-if="data">
        <template v-if="data.items.length > 0">
          <div class="mb-3">
            <template
              v-for="[date, orders] in ordersGroupedByDate"
              :key="date"
            >
              <div class="px-2 py-3 text-sm">
                {{ date }}
              </div>
              <ol class="-mx-2 mb-6 space-y-1 py-px">
                <template
                  v-for="order in orders"
                  :key="order.id"
                >
                  <li>
                    <RouterLink
                      :to="{
                        name: 'historyOrdersDetail',
                        params: { orderId: order.id },
                      }"
                    >
                      <OrdersIndexListItem :order="order" />
                    </RouterLink>
                  </li>
                </template>
              </ol>
            </template>
          </div>
          <div class="mb-4 flex justify-around px-8">
            <BasePagination
              v-model="page"
              :page-count="pageCount"
            />
          </div>
        </template>

        <template v-else>
          <p
            class="text-background-fg/70 w-full px-8 py-4 text-center"
          >
            No transactions to display
          </p>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ListOrdersResponseItem } from "@/services/orders/listOrders"
const filters = reactive({
  deviceId: undefined,
  cashierId: undefined,
})
const searchRaw = ref<string>("")

const search = refDebounced(searchRaw, 750)
const dateFilter = ref<{ start?: string; end?: string }>({
  start: undefined,
  end: undefined,
})
const { pagination, page, pageCount, resetPagination } =
  usePagination({
    limit: 10,
    count: computed(() => data.value?.count || 0),
  })

watch(
  () => [filters, dateFilter, search],
  () => resetPagination(),
  { deep: true, immediate: true }
)
const query = reactiveComputed(() => ({
  ...filters,
  ...dateFilter.value,
  search: search.value?.trim(),
  ...pagination.value,
}))
const { data } = useOrders(query)

const ordersGroupedByDate = computed(() => {
  if (!data.value) return
  return data.value.items.reduce((accumulator, order) => {
    const datePart = formatToDate(order.createdAt)
    return accumulator.set(datePart, [
      ...(accumulator.get(datePart) || []),
      order,
    ])
  }, new Map<string, Array<ListOrdersResponseItem>>())
})
</script>
